export const FROM_DASHBOARD: string = "FROM_DASHBOARD";
export const FROM_DASHBOARD_DOC_OUT: string = "FROM_DASHBOARD_DOC_OUT";
export const FROM_DASHBOARD_TASK: string = "FROM_DASHBOARD_TASK";
